import { VipTaskItemValidateFormValues } from './types';

export const VIP_TASK_ITEM_VALIDATE_FORM_INITIAL_VALUES: VipTaskItemValidateFormValues = {
  documentId: '',
};
